/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-21 23:39:57
 * @FilePath: \hippo-web-admin\src\store\getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * vuex getter
 */
export default {
  userInfo: (state) => state.user.userInfo,
  theme: (state) => state.theme,
  memberSetting: (state) => state.user.memberSetting,
  lang: (state) => state.lang,
  showUserInfo: (state) => state.user.showUserInfo,
  showSetting: (state) => state.user.showSetting,
};
